export abstract class FormValidator {
  setAnswer(dynamicFormId: string, questionId: string, answer: any) { };
}
